import { httpClient } from '../../httpClient'

export type IdeaUserForFilter = {
  id: string
  name: string
  area: {
    id: string
    name: string
  } | null
}

type ListIdeaUsersResponse = {
  users: IdeaUserForFilter[]
}

export async function listIdeaUsers(): Promise<IdeaUserForFilter[]> {
  const { data } =
    await httpClient.get<ListIdeaUsersResponse>(`ideas/ideas/users`)

  return data.users
}
